import { Box, BoxProps } from "@mui/material";
import { useSticky } from "@covertree/hooks";

interface StickyContainerProps extends BoxProps {
  children: React.ReactNode;
  topOffset?: number;
  isD2C?: boolean;
}

export function StickyContainer({
  children,
  topOffset = 24,
  isD2C = false,
  ...props
}: StickyContainerProps) {
  const { shouldStick, contentRef } = useSticky({
    isD2C,
  });

  return (
    <Box
      ref={contentRef}
      {...props}
      sx={{
        position: { xs: "static", md: shouldStick ? "sticky" : "static" },
        top: { md: shouldStick ? topOffset : "auto" },
        alignSelf: { md: shouldStick ? "flex-start" : "auto" },
        height: { md: shouldStick ? "fit-content" : "auto" },
        ...props.sx,
      }}>
      {children}
    </Box>
  );
}
